import { NotificationButton } from "Components/UI/Button/NotificationButton";
import styles from "./styles.module.scss";

function NotificationAction({ action, onAction, compact }) {
  const variant = action.variant;

  const handleClick = async (event) => {
    event.stopPropagation();
    if (action.method === "GET") return;
    await onAction?.(action);
  };

  if (action.method === "GET") {
    return (
      <NotificationButton
        variant={variant}
        to={action.url}
        showIcon={!compact}
        className={compact ? styles.compactAction : undefined}
        onClick={(event) => event.stopPropagation()}
      >
        {action.label}
      </NotificationButton>
    );
  }

  return (
    <NotificationButton
      variant={variant}
      onClick={handleClick}
      showIcon={!compact && variant !== "danger"}
      className={compact ? styles.compactAction : undefined}
    >
      {action.label}
    </NotificationButton>
  );
}

export function NotificationActions({ actions, onAction, compact }) {
  return (
    <div className={styles.actions}>
      {actions.map((action) => (
        <NotificationAction
          key={`${action.label}-${action.method}-${action.url}`}
          action={action}
          onAction={onAction}
          compact={compact}
        />
      ))}
    </div>
  );
}
